import { AbstractControl, ValidatorFn } from '@angular/forms';
import { ErrorMessage } from '../constants/error-message.constants';
import { FormHelper } from '../utilities/form.helper';

export function numberValidator(control: AbstractControl): { [key: string]: any } | null {
    if (!FormHelper.isEmptyControl(control) && isNaN(control.value)) {
        return {
            number: { message: ErrorMessage.number }
        };
    }

    return null;
}

export function disallowZeroValidator(control: AbstractControl): { [key: string]: any } | null {
    const validationErrors = numberValidator(control);
    if (validationErrors) {
        return validationErrors;
    } else if (!FormHelper.isEmptyControl(control) && +control.value === 0) {
        return {
            disallowZero: { message: ErrorMessage.disallowZero }
        };
    }

    return null;
}

export function positiveNumberValidator(control: AbstractControl): { [key: string]: any } | null {
    const validationErrors = numberValidator(control);
    if (validationErrors) {
        return validationErrors;
    } else if (!FormHelper.isEmptyControl(control) && +control.value <= 0) {
        return {
            positiveNumber: { message: ErrorMessage.positiveNumber }
        };
    }

    return null;
}

export function zeroOrGreaterNumberValidator(
    control: AbstractControl
): { [key: string]: any } | null {
    const validationErrors = numberValidator(control);
    if (validationErrors) {
        return validationErrors;
    } else if (!FormHelper.isEmptyControl(control) && +control.value < 0) {
        return {
            zeroOrGreaterNumber: { message: ErrorMessage.zeroOrGreaterNumber }
        };
    }

    return null;
}

export function wholeNumberValidator(control: AbstractControl): { [key: string]: any } | null {
    const validationErrors = numberValidator(control);
    if (validationErrors) {
        return validationErrors;
    } else if (!FormHelper.isEmptyControl(control) && !Number.isInteger(+control.value)) {
        return {
            wholeNumber: { message: ErrorMessage.wholeNumber }
        };
    }

    return null;
}

export function maxNumberValidator(max: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const validationErrors = numberValidator(control);
        if (validationErrors) {
            return validationErrors;
        } else if (!FormHelper.isEmptyControl(control) && +control.value > max) {
            return {
                maxNumber: { message: ErrorMessage.maxNumber(max) }
            };
        }

        return null;
    };
}

export function minNumberValidator(min: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const validationErrors = numberValidator(control);
        if (validationErrors) {
            return validationErrors;
        } else if (!FormHelper.isEmptyControl(control) && +control.value < min) {
            return {
                minNumber: { message: ErrorMessage.minNumber(min) }
            };
        }

        return null;
    };
}

export function keyValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const validationErrors = numberValidator(control);
        if (validationErrors) {
            return validationErrors;
        } else if (!FormHelper.isEmptyControl(control) && +control.value < 1) {
            return {
                minNumber: { message: ErrorMessage.minNumber(1) }
            };
        }

        return null;
    };
}

export function numberRangeValidator(min: number, max: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const validationErrors = numberValidator(control);
        if (validationErrors) {
            return validationErrors;
        } else if (
            !FormHelper.isEmptyControl(control) &&
            (+control.value < min || +control.value > max)
        ) {
            return {
                numberRange: { message: ErrorMessage.numberRange(min, max) }
            };
        }

        return null;
    };
}

export function lessThanNumberValidator(value: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const validationErrors = numberValidator(control);
        if (validationErrors) {
            return validationErrors;
        } else if (!FormHelper.isEmptyControl(control) && +control.value >= value) {
            return {
                numberRange: { message: ErrorMessage.lessThan(value) }
            };
        }

        return null;
    };
}
